import { render } from "./CommentNotificationItem.vue?vue&type=template&id=15acbc62&scoped=true&ts=true"
import script from "./CommentNotificationItem.vue?vue&type=script&lang=ts"
export * from "./CommentNotificationItem.vue?vue&type=script&lang=ts"

import "./CommentNotificationItem.vue?vue&type=style&index=0&id=15acbc62&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15acbc62"]])

export default __exports__